// Comprehensive list of world countries with major cities
// Countries with Turkish diaspora have more detailed city/district data

export const worldCountries = {
  // Europe
  "Türkiye": {
    "İstanbul": ["Kadıköy", "Kartal", "Maltepe", "Üsküdar", "Beşiktaş", "Şişli", "Beyoğlu", "Fatih", "Bakırköy", "Ataşehir", "Pendik", "Tuzla", "Ümraniye", "Bağcılar", "Bahçelievler", "Esenler", "Sultangazi", "Gaziosmanpaşa", "Eyüpsultan", "Sarıyer", "Çekmeköy", "Sancaktepe", "Sultanbeyli", "Başakşehir", "Küçükçekmece", "Büyükçekmece", "Avcılar", "Esenyurt", "Beylikdüzü", "Silivri", "Çatalca", "Arnavutköy", "Şile", "Adalar", "Beykoz"],
    "Ankara": ["Çankaya", "Keçiören", "Yenimahalle", "Mamak", "Etimesgut", "Sincan", "Altındağ", "Pursaklar", "Gölbaşı", "Polatlı", "Beypazarı", "Çubuk", "Kahramankazan"],
    "İzmir": ["Konak", "Karşıyaka", "Bornova", "Buca", "Çiğli", "Bayraklı", "Balçova", "Gaziemir", "Narlıdere", "Karabağlar", "Menemen", "Aliağa", "Torbalı", "Kemalpaşa", "Bergama", "Tire", "Ödemiş", "Urla", "Seferihisar", "Dikili"],
    "Antalya": ["Muratpaşa", "Konyaaltı", "Kepez", "Aksu", "Alanya", "Manavgat", "Serik", "Kaş", "Kumluca", "Finike", "Kemer", "Demre", "Gazipaşa"],
    "Bursa": ["Osmangazi", "Nilüfer", "Yıldırım", "Mudanya", "Gemlik", "İnegöl", "Gürsu", "Kestel", "Orhangazi", "Mustafakemalpaşa"],
    "Adana": ["Seyhan", "Yüreğir", "Çukurova", "Sarıçam", "Ceyhan", "Kozan", "İmamoğlu", "Karaisalı"],
    "Konya": ["Selçuklu", "Meram", "Karatay", "Ereğli", "Akşehir", "Beyşehir", "Seydişehir", "Çumra", "Cihanbeyli"],
    "Gaziantep": ["Şahinbey", "Şehitkamil", "Oğuzeli", "Nizip", "İslahiye", "Nurdağı", "Araban"],
    "Mersin": ["Yenişehir", "Toroslar", "Akdeniz", "Mezitli", "Tarsus", "Erdemli", "Silifke", "Anamur"],
    "Kayseri": ["Melikgazi", "Kocasinan", "Talas", "Hacılar", "İncesu", "Develi"],
    "Eskişehir": ["Tepebaşı", "Odunpazarı", "Sivrihisar", "Çifteler"],
    "Diyarbakır": ["Bağlar", "Kayapınar", "Yenişehir", "Sur", "Bismil", "Ergani", "Silvan"],
    "Samsun": ["İlkadım", "Atakum", "Canik", "Tekkeköy", "Bafra", "Çarşamba", "Terme"],
    "Denizli": ["Merkezefendi", "Pamukkale", "Çivril", "Acıpayam", "Tavas"],
    "Şanlıurfa": ["Eyyübiye", "Haliliye", "Karaköprü", "Siverek", "Viranşehir", "Harran"],
    "Trabzon": ["Ortahisar", "Akçaabat", "Yomra", "Araklı", "Of", "Sürmene"],
    "Malatya": ["Battalgazi", "Yeşilyurt", "Darende", "Doğanşehir"],
    "Erzurum": ["Yakutiye", "Palandöken", "Aziziye", "Horasan", "Oltu"],
    "Van": ["İpekyolu", "Tuşba", "Edremit", "Erciş", "Özalp"],
    "Batman": ["Merkez", "Kozluk", "Sason"],
    "Elazığ": ["Merkez", "Kovancılar", "Karakoçan"],
    "Sakarya": ["Adapazarı", "Serdivan", "Erenler", "Arifiye", "Hendek", "Sapanca"],
    "Kocaeli": ["İzmit", "Gebze", "Darıca", "Körfez", "Derince", "Gölcük", "Kandıra", "Kartepe"],
    "Manisa": ["Yunusemre", "Şehzadeler", "Akhisar", "Turgutlu", "Salihli", "Soma"],
    "Balıkesir": ["Altıeylül", "Karesi", "Bandırma", "Edremit", "Gönen", "Ayvalık", "Burhaniye"],
    "Muğla": ["Bodrum", "Marmaris", "Fethiye", "Milas", "Dalaman", "Datça", "Köyceğiz", "Ortaca"],
    "Aydın": ["Efeler", "Nazilli", "Kuşadası", "Didim", "Söke", "Çine", "Germencik"],
    "Tekirdağ": ["Süleymanpaşa", "Çorlu", "Çerkezköy", "Ergene", "Saray", "Malkara"],
    "Edirne": ["Merkez", "Keşan", "Uzunköprü", "İpsala", "Havsa"],
    "Kırklareli": ["Merkez", "Lüleburgaz", "Babaeski", "Vize", "Pınarhisar"],
    "Çanakkale": ["Merkez", "Biga", "Çan", "Gelibolu", "Ayvacık", "Ezine"],
    "Hatay": ["Antakya", "İskenderun", "Defne", "Arsuz", "Samandağ", "Dörtyol", "Kırıkhan", "Reyhanlı"],
    "Kahramanmaraş": ["Onikişubat", "Dulkadiroğlu", "Elbistan", "Afşin", "Türkoğlu", "Pazarcık"],
    "Mardin": ["Artuklu", "Kızıltepe", "Midyat", "Nusaybin", "Derik"],
    "Afyonkarahisar": ["Merkez", "Sandıklı", "Dinar", "Bolvadin", "Emirdağ"],
    "Kütahya": ["Merkez", "Tavşanlı", "Simav", "Gediz"],
    "Isparta": ["Merkez", "Yalvaç", "Şarkikaraağaç", "Eğirdir"],
    "Bolu": ["Merkez", "Gerede", "Mudurnu"],
    "Düzce": ["Merkez", "Akçakoca", "Kaynaşlı"],
    "Karabük": ["Merkez", "Safranbolu", "Eskipazar"],
    "Zonguldak": ["Merkez", "Ereğli", "Çaycuma", "Devrek"],
    "Bartın": ["Merkez", "Amasra"],
    "Kastamonu": ["Merkez", "Tosya", "Taşköprü", "İnebolu"],
    "Sinop": ["Merkez", "Boyabat", "Gerze", "Ayancık"],
    "Çorum": ["Merkez", "Sungurlu", "Alaca", "İskilip"],
    "Amasya": ["Merkez", "Merzifon", "Suluova", "Taşova"],
    "Tokat": ["Merkez", "Turhal", "Erbaa", "Niksar", "Zile"],
    "Sivas": ["Merkez", "Şarkışla", "Yıldızeli", "Suşehri"],
    "Yozgat": ["Merkez", "Sorgun", "Akdağmadeni", "Boğazlıyan"],
    "Kırşehir": ["Merkez", "Kaman", "Mucur"],
    "Nevşehir": ["Merkez", "Ürgüp", "Avanos", "Göreme", "Derinkuyu"],
    "Aksaray": ["Merkez", "Ortaköy", "Güzelyurt"],
    "Niğde": ["Merkez", "Bor", "Ulukışla"],
    "Karaman": ["Merkez", "Ermenek"],
    "Adıyaman": ["Merkez", "Kahta", "Besni", "Gölbaşı"],
    "Kilis": ["Merkez", "Musabeyli"],
    "Osmaniye": ["Merkez", "Kadirli", "Düziçi"],
    "Şırnak": ["Merkez", "Cizre", "Silopi", "İdil"],
    "Siirt": ["Merkez", "Kurtalan", "Baykan"],
    "Bitlis": ["Merkez", "Tatvan", "Ahlat", "Güroymak"],
    "Muş": ["Merkez", "Malazgirt", "Bulanık", "Varto"],
    "Hakkari": ["Merkez", "Yüksekova", "Çukurca"],
    "Ağrı": ["Merkez", "Doğubayazıt", "Patnos", "Eleşkirt"],
    "Iğdır": ["Merkez", "Tuzluca"],
    "Kars": ["Merkez", "Sarıkamış", "Kağızman"],
    "Ardahan": ["Merkez", "Göle", "Posof"],
    "Artvin": ["Merkez", "Hopa", "Arhavi", "Borçka"],
    "Rize": ["Merkez", "Çayeli", "Ardeşen", "Pazar", "Fındıklı"],
    "Gümüşhane": ["Merkez", "Kelkit", "Şiran"],
    "Bayburt": ["Merkez", "Aydıntepe"],
    "Giresun": ["Merkez", "Bulancak", "Espiye", "Tirebolu"],
    "Ordu": ["Altınordu", "Ünye", "Fatsa", "Perşembe"],
    "Tunceli": ["Merkez", "Pertek", "Çemişgezek"],
    "Bingöl": ["Merkez", "Genç", "Karlıova", "Solhan"],
    "Uşak": ["Merkez", "Banaz", "Sivaslı"],
    "Bilecik": ["Merkez", "Bozüyük", "Söğüt"],
    "Yalova": ["Merkez", "Çınarcık", "Armutlu", "Altınova"],
    "Çankırı": ["Merkez", "Çerkeş", "Ilgaz"],
    "Kırıkkale": ["Merkez", "Yahşihan", "Keskin", "Delice"],
  },
  "Germany": {
    "Berlin": ["Kreuzberg", "Neukölln", "Wedding", "Charlottenburg", "Mitte", "Friedrichshain", "Prenzlauer Berg", "Schöneberg", "Tempelhof", "Spandau", "Reinickendorf", "Steglitz", "Lichtenberg", "Pankow", "Treptow", "Köpenick", "Marzahn", "Hellersdorf"],
    "Munich": ["Schwabing", "Sendling", "Maxvorstadt", "Haidhausen", "Bogenhausen", "Pasing", "Milbertshofen", "Moosach", "Laim", "Neuhausen", "Giesing", "Trudering", "Riem", "Berg am Laim"],
    "Frankfurt": ["Sachsenhausen", "Bornheim", "Nordend", "Gallus", "Bockenheim", "Höchst", "Rödelheim", "Niederrad", "Fechenheim", "Seckbach", "Griesheim"],
    "Hamburg": ["Altona", "St. Pauli", "Eimsbüttel", "Wandsbek", "Harburg", "Bergedorf", "Billstedt", "Wilhelmsburg", "Barmbek", "Winterhude", "Eppendorf", "Uhlenhorst", "Ottensen"],
    "Cologne": ["Ehrenfeld", "Nippes", "Mülheim", "Kalk", "Porz", "Lindenthal", "Chorweiler", "Rodenkirchen", "Deutz", "Innenstadt", "Sülz", "Bayenthal"],
    "Stuttgart": ["Mitte", "Bad Cannstatt", "Feuerbach", "Zuffenhausen", "Vaihingen", "Degerloch", "Sillenbuch", "Möhringen", "Untertürkheim", "Wangen"],
    "Düsseldorf": ["Altstadt", "Bilk", "Oberbilk", "Flingern", "Gerresheim", "Derendorf", "Pempelfort", "Unterbilk", "Eller", "Benrath", "Wersten"],
    "Dortmund": ["Innenstadt", "Hörde", "Eving", "Scharnhorst", "Brackel", "Hombruch", "Mengede", "Lütgendortmund", "Aplerbeck"],
    "Essen": ["Stadtmitte", "Altenessen", "Katernberg", "Steele", "Borbeck", "Rüttenscheid", "Werden", "Kettwig", "Frohnhausen"],
    "Bremen": ["Mitte", "Gröpelingen", "Hemelingen", "Vahr", "Osterholz", "Neustadt", "Schwachhausen", "Horn-Lehe", "Walle", "Findorff"],
    "Hannover": ["Mitte", "Linden", "Vahrenwald", "List", "Döhren", "Ricklingen", "Südstadt", "Nordstadt", "Bothfeld", "Herrenhausen"],
    "Leipzig": ["Zentrum", "Connewitz", "Plagwitz", "Reudnitz", "Grünau", "Gohlis", "Lindenau", "Schönefeld", "Mockau", "Eutritzsch"],
    "Dresden": ["Altstadt", "Neustadt", "Blasewitz", "Striesen", "Gorbitz", "Prohlis", "Laubegast", "Löbtau", "Pieschen", "Cotta"],
    "Nürnberg": ["Altstadt", "Gostenhof", "St. Johannis", "Südstadt", "Langwasser", "Maxfeld", "Wöhrd", "Ziegelstein", "Mögeldorf"],
    "Duisburg": ["Mitte", "Marxloh", "Hamborn", "Hochfeld", "Meiderich", "Ruhrort", "Rheinhausen", "Homberg", "Walsum"],
    "Mannheim": ["Innenstadt", "Neckarstadt", "Jungbusch", "Waldhof", "Käfertal", "Lindenhof", "Sandhofen", "Feudenheim", "Seckenheim"],
    "Karlsruhe": ["Innenstadt", "Mühlburg", "Durlach", "Weststadt", "Südstadt", "Oststadt", "Grötzingen", "Hagsfeld", "Neureut"],
    "Wiesbaden": ["Mitte", "Biebrich", "Kastel", "Kostheim", "Schierstein", "Dotzheim", "Erbenheim", "Bierstadt", "Sonnenberg"],
    "Mainz": ["Altstadt", "Neustadt", "Mombach", "Gonsenheim", "Finthen", "Bretzenheim", "Hechtsheim", "Weisenau", "Lerchenberg"],
    "Gelsenkirchen": ["Mitte", "Buer", "Horst", "Schalke", "Bismarck", "Erle", "Resse", "Hassel", "Ückendorf"],
    "Bochum": ["Mitte", "Wattenscheid", "Langendreer", "Gerthe", "Weitmar", "Dahlhausen", "Stiepel", "Linden", "Querenburg"],
    "Wuppertal": ["Elberfeld", "Barmen", "Vohwinkel", "Cronenberg", "Ronsdorf", "Langerfeld", "Oberbarmen", "Unterbarmen"],
    "Bielefeld": ["Mitte", "Brackwede", "Schildesche", "Sennestadt", "Gadderbaum", "Stieghorst", "Heepen", "Jöllenbeck", "Dornberg"],
    "Bonn": ["Zentrum", "Bad Godesberg", "Beuel", "Hardtberg", "Endenich", "Poppelsdorf", "Kessenich", "Dottendorf", "Tannenbusch"],
    "Münster": ["Altstadt", "Gievenbeck", "Kinderhaus", "Hiltrup", "Roxel", "Handorf", "Amelsbüren", "Wolbeck", "Berg Fidel"],
    "Augsburg": ["Innenstadt", "Oberhausen", "Lechhausen", "Haunstetten", "Göggingen", "Kriegshaber", "Pfersee"],
    "Aachen": ["Mitte", "Burtscheid", "Eilendorf", "Brand", "Laurensberg", "Haaren", "Richterich"],
    "Braunschweig": ["Innenstadt", "Weststadt", "Östliches Ringgebiet", "Heidberg", "Stöckheim", "Wenden", "Lehndorf"],
    "Kiel": ["Mitte", "Gaarden", "Ellerbek", "Wellingdorf", "Mettenhof", "Dietrichsdorf", "Hassee"],
    "Chemnitz": ["Zentrum", "Kaßberg", "Schloßchemnitz", "Gablenz", "Sonnenberg", "Reichenhain", "Bernsdorf"],
    "Halle": ["Altstadt", "Neustadt", "Trotha", "Heide-Süd", "Silberhöhe", "Nietleben", "Kröllwitz"],
    "Magdeburg": ["Altstadt", "Neustadt", "Buckau", "Sudenburg", "Stadtfeld", "Cracau", "Herrenkrug"],
    "Freiburg": ["Altstadt", "Wiehre", "Herdern", "Stühlinger", "Haslach", "Landwasser", "Littenweiler"],
    "Krefeld": ["Mitte", "Uerdingen", "Fischeln", "Oppum", "Hüls", "Bockum", "Linn"],
    "Lübeck": ["Altstadt", "St. Lorenz", "Moisling", "Kücknitz", "Travemünde", "Schlutup", "Buntekuh"],
    "Oberhausen": ["Mitte", "Sterkrade", "Osterfeld", "Alstaden", "Lirich", "Borbeck"],
    "Erfurt": ["Altstadt", "Rieth", "Herrenberg", "Melchendorf", "Wiesenhügel", "Daberstedt", "Löbervorstadt"],
    "Rostock": ["Stadtmitte", "Warnemünde", "Lütten Klein", "Evershagen", "Dierkow", "Toitenwinkel"],
    "Kassel": ["Mitte", "Wehlheiden", "Rothenditmold", "Niederzwehren", "Oberzwehren", "Waldau", "Bettenhausen"],
    "Hagen": ["Mitte", "Haspe", "Hohenlimburg", "Eilpe", "Boele", "Vorhalle", "Wehringhausen"],
    "Saarbrücken": ["Mitte", "St. Johann", "Alt-Saarbrücken", "Malstatt", "Burbach", "Dudweiler", "Brebach"],
    "Mönchengladbach": ["Altstadt", "Rheydt", "Wickrath", "Giesenkirchen", "Odenkirchen", "Neuwerk", "Hardt"],
    "Potsdam": ["Innenstadt", "Babelsberg", "Drewitz", "Stern", "Golm", "Bornim", "Grube"],
    "Ludwigshafen": ["Mitte", "Oggersheim", "Oppau", "Friesenheim", "Mundenheim", "Rheingönheim", "Gartenstadt"],
    "Oldenburg": ["Innenstadt", "Eversten", "Kreyenbrück", "Bürgerfelde", "Donnerschwee", "Osternburg"],
    "Leverkusen": ["Mitte", "Wiesdorf", "Opladen", "Schlebusch", "Quettingen", "Manfort"],
    "Solingen": ["Mitte", "Ohligs", "Wald", "Gräfrath", "Höhscheid", "Merscheid"],
    "Osnabrück": ["Innenstadt", "Wüste", "Dodesheide", "Eversburg", "Schinkel", "Sonnenhügel"],
    "Heidelberg": ["Altstadt", "Bergheim", "Weststadt", "Neuenheim", "Handschuhsheim", "Rohrbach", "Kirchheim"],
    "Regensburg": ["Altstadt", "Stadtamhof", "Kumpfmühl", "Kasernenviertel", "Schwabelweis", "Burgweinting"],
    "Paderborn": ["Innenstadt", "Schloß Neuhaus", "Elsen", "Sande", "Wewer", "Mastbruch"],
    "Ingolstadt": ["Mitte", "Ringsee", "Haunwöhr", "Friedrichshofen", "Oberhaunstadt", "Zuchering"],
    "Würzburg": ["Altstadt", "Sanderau", "Frauenland", "Grombühl", "Zellerau", "Versbach"],
    "Ulm": ["Innenstadt", "Böfingen", "Wiblingen", "Söflingen", "Eselsberg", "Weststadt"],
    "Wolfsburg": ["Stadtmitte", "Fallersleben", "Vorsfelde", "Westhagen", "Detmerode", "Nordstadt"],
    "Göttingen": ["Innenstadt", "Grone", "Geismar", "Weende", "Nikolausberg", "Herberhausen"],
    "Recklinghausen": ["Altstadt", "Süd", "Hochlarmark", "Suderwich", "König Ludwig"],
    "Heilbronn": ["Innenstadt", "Böckingen", "Sontheim", "Frankenbach", "Neckargartach"],
    "Pforzheim": ["Innenstadt", "Nordstadt", "Oststadt", "Weststadt", "Brötzingen", "Dillweißenstein"],
    "Offenbach": ["Innenstadt", "Bürgel", "Bieber", "Lauterborn", "Tempelsee"],
    "Bottrop": ["Mitte", "Boy", "Welheim", "Kirchhellen", "Grafenwald"],
    "Remscheid": ["Mitte", "Lennep", "Lüttringhausen", "Hasten", "Honsberg"],
  },
  "Netherlands": {
    "Amsterdam": ["De Pijp", "Oost", "West", "Noord", "Centrum", "Zuidoost", "Nieuw-West", "Buitenveldert", "IJburg", "Watergraafsmeer", "Westerpark", "Oud-Zuid"],
    "Rotterdam": ["Centrum", "Kralingen", "Delfshaven", "Feijenoord", "Charlois", "IJsselmonde", "Prins Alexander", "Hillegersberg", "Overschie", "Hoogvliet", "Pernis", "Rozenburg"],
    "The Hague": ["Centrum", "Scheveningen", "Laak", "Escamp", "Segbroek", "Loosduinen", "Haagse Hout", "Leidschenveen", "Ypenburg", "Mariahoeve"],
    "Utrecht": ["Centrum", "Lombok", "Overvecht", "Leidsche Rijn", "Kanaleneiland", "Zuilen", "Lunetten", "Hoograven", "Tuindorp", "Wittevrouwen", "Vogelenbuurt"],
    "Eindhoven": ["Centrum", "Woensel", "Stratum", "Gestel", "Strijp", "Tongelre", "Meerhoven", "Veldhoven"],
    "Tilburg": ["Centrum", "Noord", "West", "Reeshof", "Berkel-Enschot", "Udenhout", "Goirle"],
    "Groningen": ["Centrum", "Paddepoel", "Vinkhuizen", "Lewenborg", "Helpman", "Beijum", "Selwerd", "Corpus den Hoorn"],
    "Almere": ["Stad", "Haven", "Buiten", "Poort", "Hout", "Muziekwijk", "Filmwijk"],
    "Breda": ["Centrum", "Princenhage", "Bavel", "Teteringen", "Ginneken", "Tuinzigt", "Haagse Beemden"],
    "Nijmegen": ["Centrum", "Dukenburg", "Lindenholt", "Hatert", "Neerbosch", "Lent", "Brakkenstein"],
    "Arnhem": ["Centrum", "Presikhaaf", "Malburgen", "Kronenburg", "Velperweg", "Klarendal", "Geitenkamp"],
    "Haarlem": ["Centrum", "Schalkwijk", "Noord", "Oost", "Meerwijk", "Molenwijk"],
    "Zaandam": ["Centrum", "Poelenburg", "Peldersveld", "Westerkoog", "Zaandam-Zuid"],
    "Amersfoort": ["Centrum", "Liendert", "Soesterkwartier", "Vathorst", "Hoogland", "Nieuwland", "Kattenbroek"],
    "Apeldoorn": ["Centrum", "De Maten", "Osseveld", "Ugchelen", "Orden", "Berg en Bos"],
    "Enschede": ["Centrum", "Wesselerbrink", "Glanerbrug", "Pathmos", "Lonneker", "Boekelo", "Roombeek"],
    "Deventer": ["Centrum", "Keizerslanden", "Rivierenwijk", "Colmschate", "Bathmen"],
    "Zwolle": ["Centrum", "Stadshagen", "Holtenbroek", "Berkum", "Westenholte", "Assendorp"],
    "Leiden": ["Centrum", "Stevenshof", "Merenwijk", "Leiderdorp", "Oegstgeest", "Mors", "Groenoord"],
    "Maastricht": ["Centrum", "Wyck", "Céramique", "Randwyck", "Heer", "Amby", "Biesland", "Limmel"],
    "Dordrecht": ["Centrum", "Krispijn", "Stadspolders", "Sterrenburg", "Dubbeldam", "Wielwijk"],
    "Zoetermeer": ["Centrum", "Meerzicht", "Rokkeveen", "Oosterheem", "Palenstein", "Buytenwegh"],
    "Haarlemmermeer": ["Hoofddorp", "Nieuw-Vennep", "Zwanenburg", "Badhoevedorp", "Cruquius"],
    "Delft": ["Centrum", "Tanthof", "Voorhof", "Buitenhof", "Wippolder", "Hof van Delft"],
    "Alkmaar": ["Centrum", "Overdie", "De Mare", "Oudorp", "Koedijk"],
    "Emmen": ["Centrum", "Angelslo", "Bargeres", "Emmerhout", "Rietlanden"],
    "Venlo": ["Centrum", "Blerick", "Tegelen", "Belfeld", "Arcen"],
    "Leeuwarden": ["Centrum", "Camminghaburen", "Aldlân", "Bilgaard", "Heechterp"],
    "Den Bosch": ["Centrum", "West", "Maaspoort", "De Groote Wielen", "Rosmalen", "Empel"],
    "Helmond": ["Centrum", "Helmond-West", "Rijpelberg", "Brouwhuis", "Brandevoort"],
    "Hilversum": ["Centrum", "Noord", "Zuid", "Oost", "Kerkelanden"],
    "Heerlen": ["Centrum", "Hoensbroek", "Heerlerheide", "Meezenbroek"],
    "Oss": ["Centrum", "Ruwaard", "Schadewijk", "Berghem"],
    "Sittard-Geleen": ["Sittard", "Geleen", "Born", "Munstergeleen"],
    "Purmerend": ["Centrum", "Weidevenne", "Wheermolen", "Overwhere"],
    "Schiedam": ["Centrum", "Nieuwland", "Groenoord", "Spaland"],
    "Spijkenisse": ["Centrum", "Waterland", "Hoogwerf", "Schenkel"],
    "Vlaardingen": ["Centrum", "Holy", "Westwijk", "Vlaardinger Ambacht"],
    "Amstelveen": ["Centrum", "Westwijk", "Bankras", "Kostverloren", "Waardhuizen"],
    "Capelle aan den IJssel": ["Centrum", "Oostgaarde", "Schollevaar", "Schenkel"],
    "Hoorn": ["Centrum", "Risdam", "Kersenboogerd", "De Grote Waal"],
    "Lelystad": ["Centrum", "Zuiderzeewijk", "Waterwijk", "Botter"],
    "Roosendaal": ["Centrum", "Langdonk", "Kroeven", "Kalsdonk"],
    "Gouda": ["Centrum", "Goverwelle", "Plaswijck", "Bloemendaal"],
  },
  "Belgium": {
    "Brussels": ["Schaerbeek", "Saint-Gilles", "Molenbeek", "Ixelles", "Anderlecht", "Forest", "Etterbeek", "Jette", "Evere", "Koekelberg"],
    "Antwerp": ["Centrum", "Borgerhout", "Berchem", "Deurne", "Hoboken", "Merksem", "Wilrijk"],
    "Ghent": ["Centrum", "Ledeberg", "Gentbrugge", "Sint-Amandsberg", "Mariakerke"],
    "Charleroi": ["Centre", "Marchienne", "Jumet", "Gosselies", "Gilly"],
    "Liège": ["Centre", "Outremeuse", "Guillemins", "Angleur", "Bressoux"],
    "Bruges": ["Centrum", "Sint-Andries", "Sint-Michiels"],
    "Namur": ["Centre", "Jambes", "Saint-Servais"],
    "Leuven": ["Centrum", "Kessel-Lo", "Heverlee"],
    "Mechelen": ["Centrum", "Nekkerspoel", "Battel"],
    "Aalst": ["Centrum", "Nieuwerkerken", "Erembodegem"],
  },
  "France": {
    "Paris": ["Belleville", "Barbès", "La Chapelle", "Strasbourg Saint-Denis", "Ménilmontant", "Montreuil", "Saint-Denis", "Aubervilliers", "Bobigny", "Pantin", "La Courneuve", "Drancy", "Bondy", "Créteil", "Vitry-sur-Seine"],
    "Marseille": ["La Canebière", "Noailles", "Belsunce", "Belle de Mai", "Le Panier", "Nord", "La Rose"],
    "Lyon": ["Guillotière", "Part-Dieu", "Vaise", "Vénissieux", "Villeurbanne", "Bron", "Vaulx-en-Velin"],
    "Toulouse": ["Centre", "Le Mirail", "Empalot", "Bagatelle", "Bellefontaine"],
    "Nice": ["Centre", "L'Ariane", "Les Moulins", "Saint-Roch"],
    "Strasbourg": ["Centre", "Cronenbourg", "Hautepierre", "Neuhof", "Meinau", "Koenigshoffen"],
    "Lille": ["Centre", "Wazemmes", "Fives", "Moulins", "Roubaix", "Tourcoing"],
    "Bordeaux": ["Centre", "Bastide", "Saint-Michel", "Bacalan"],
    "Nantes": ["Centre", "Bellevue", "Dervallières", "Malakoff"],
    "Montpellier": ["Centre", "La Paillade", "Mosson", "Figuerolles"],
    "Rennes": ["Centre", "Villejean", "Maurepas", "Le Blosne"],
    "Grenoble": ["Centre", "Villeneuve", "Mistral", "Teisseire"],
    "Rouen": ["Centre", "Saint-Sever", "Grand'Mare", "Sotteville"],
    "Dijon": ["Centre", "Grésilles", "Fontaine d'Ouche"],
    "Mulhouse": ["Centre", "Bourtzwiller", "Dornach", "Coteaux"],
  },
  "United Kingdom": {
    "London": ["Hackney", "Haringey", "Enfield", "Walthamstow", "Edmonton", "Tottenham", "Stoke Newington", "Dalston", "Islington", "Camden", "Lewisham", "Greenwich", "Barking", "Ilford", "Stratford", "Woolwich", "Brixton", "Peckham", "Croydon"],
    "Birmingham": ["Sparkbrook", "Small Heath", "Alum Rock", "Aston", "Handsworth", "Sparkhill", "Bordesley Green", "Lozells", "Erdington"],
    "Manchester": ["Rusholme", "Longsight", "Cheetham Hill", "Moss Side", "Hulme", "Levenshulme", "Oldham", "Bolton", "Rochdale"],
    "Leeds": ["Harehills", "Beeston", "Chapeltown", "Hyde Park", "Headingley"],
    "Glasgow": ["Govanhill", "Pollokshields", "Ibrox", "Maryhill", "Springburn"],
    "Liverpool": ["Toxteth", "Wavertree", "Kensington", "Anfield", "Edge Hill"],
    "Bristol": ["Easton", "St Pauls", "Lawrence Hill", "Bedminster"],
    "Sheffield": ["Burngreave", "Darnall", "Firth Park", "Sharrow", "Nether Edge"],
    "Bradford": ["Manningham", "Girlington", "Toller Lane", "Heaton", "Little Horton"],
    "Leicester": ["Highfields", "Belgrave", "Spinney Hills", "Evington"],
    "Edinburgh": ["Leith", "Gorgie", "Haymarket", "Newington"],
    "Cardiff": ["Riverside", "Grangetown", "Splott", "Roath"],
    "Nottingham": ["Hyson Green", "Forest Fields", "Sneinton", "St Ann's"],
    "Coventry": ["Foleshill", "Hillfields", "Stoke", "Spon End"],
    "Newcastle": ["Fenham", "Elswick", "Byker", "Walker"],
  },
  "Austria": {
    "Vienna": ["Favoriten", "Ottakring", "Brigittenau", "Floridsdorf", "Hernals", "Rudolfsheim", "Simmering", "Meidling", "Leopoldstadt", "Landstraße", "Wieden", "Margareten", "Mariahilf", "Neubau", "Josefstadt", "Alsergrund", "Hietzing", "Penzing", "Währing", "Döbling", "Donaustadt", "Liesing"],
    "Graz": ["Gries", "Lend", "Jakomini", "Eggenberg", "Puntigam", "St. Leonhard", "Gösting", "Liebenau", "St. Peter", "Andritz", "Wetzelsdorf", "Straßgang", "Mariatrost", "Innere Stadt"],
    "Linz": ["Zentrum", "Urfahr", "Kleinmünchen", "Bindermichl", "Ebelsberg", "Pichling", "St. Magdalena", "Auwiesen", "Neue Heimat", "Froschberg", "Keferfeld", "Franckviertel"],
    "Salzburg": ["Elisabeth-Vorstadt", "Lehen", "Maxglan", "Itzling", "Altstadt", "Nonntal", "Parsch", "Aigen", "Gnigl", "Liefering", "Morzg", "Schallmoos", "Taxham"],
    "Innsbruck": ["Pradl", "Reichenau", "Wilten", "Saggen", "Hötting", "Mühlau", "Arzl", "Amras", "Vill", "Igls", "Hungerburg"],
    "Klagenfurt": ["Innere Stadt", "St. Ruprecht", "St. Martin", "St. Peter", "Wölfnitz", "Annabichl", "Viktring"],
    "Villach": ["Innenstadt", "St. Martin", "Lind", "Landskron", "Warmbad", "Maria Gail"],
    "Wels": ["Innenstadt", "Neustadt", "Pernau", "Vogelweide", "Lichtenegg", "Puchberg"],
    "St. Pölten": ["Innenstadt", "Spratzern", "Viehofen", "Ratzersdorf", "Wagram", "St. Georgen"],
    "Dornbirn": ["Markt", "Haselstauden", "Oberdorf", "Rohrbach", "Hatlerdorf", "Schoren"],
    "Steyr": ["Innenstadt", "Münichholz", "Tabor", "Resthof", "Gleink"],
    "Wiener Neustadt": ["Innenstadt", "Zehnerviertel", "Josefstadt", "Ungarviertel", "Flugfeld"],
    "Feldkirch": ["Innenstadt", "Altenstadt", "Tosters", "Levis", "Tisis", "Nofels"],
    "Bregenz": ["Innenstadt", "Rieden", "Vorkloster", "Schendlingen", "Fluh"],
    "Leonding": ["Zentrum", "Hart", "Rufling", "Doppl"],
    "Klosterneuburg": ["Zentrum", "Weidling", "Kierling", "Kritzendorf"],
    "Baden": ["Innenstadt", "Leesdorf", "Weikersdorf", "Braiten"],
    "Traun": ["Zentrum", "St. Martin", "Oedt", "St. Dionysen"],
    "Amstetten": ["Zentrum", "Greinsfurth", "Preinsbach", "Mauer"],
    "Kapfenberg": ["Zentrum", "Schirmitzbühel", "Diemlach", "Hafendorf"],
    "Mödling": ["Zentrum", "Vorderbrühl", "Hinterbrühl"],
    "Hallein": ["Altstadt", "Rif", "Taxach", "Burgfried"],
    "Krems": ["Altstadt", "Lerchenfeld", "Stein", "Mitterau"],
    "Schwechat": ["Zentrum", "Mannswörth", "Rannersdorf", "Kledering"],
    "Lustenau": ["Zentrum", "Hasenfeld", "Rheindorf"],
    "Wolfsberg": ["Zentrum", "St. Johann", "St. Stefan", "St. Marein"],
    "Braunau am Inn": ["Zentrum", "Ranshofen", "Laab"],
  },
  "Switzerland": {
    "Zurich": ["Oerlikon", "Altstetten", "Schwamendingen", "Seebach", "Affoltern", "Höngg", "Wipkingen", "Wiedikon", "Albisrieden", "Leimbach", "Wollishofen", "Enge"],
    "Basel": ["Kleinbasel", "Gundeldingen", "St. Johann", "Iselin", "Clara", "Matthäus", "Klybeck", "Breite", "Bruderholz", "Bachletten"],
    "Geneva": ["Les Pâquis", "Plainpalais", "Servette", "Chêne-Bourg", "Vernier", "Carouge", "Lancy", "Meyrin", "Onex", "Thônex", "Bernex"],
    "Bern": ["Bümpliz", "Bethlehem", "Lorraine", "Breitenrain", "Mattenhof", "Holligen", "Länggasse", "Kirchenfeld", "Muri", "Ostermundigen"],
    "Lausanne": ["Centre", "Chailly", "Prilly", "Renens", "Ouchy", "Vidy", "Malley", "Pully", "Lutry", "Morges"],
    "Winterthur": ["Töss", "Veltheim", "Seen", "Mattenbach", "Wülflingen", "Oberwinterthur", "Hegi", "Grüze"],
    "St. Gallen": ["Centrum", "Lachen", "Bruggen", "Rotmonten", "Tablat", "Winkeln", "Heiligkreuz"],
    "Lugano": ["Centro", "Molino Nuovo", "Pregassona", "Viganello", "Cassarate", "Paradiso", "Massagno"],
    "Lucerne": ["Altstadt", "Littau", "Reussbühl", "Würzenbach", "Tribschen", "Kriens", "Horw", "Emmen"],
    "Biel": ["Altstadt", "Mett", "Bözingen", "Madretsch", "Nidau", "Mâche"],
    "Thun": ["Altstadt", "Lerchenfeld", "Allmendingen", "Goldiwil", "Strättligen"],
    "Köniz": ["Köniz Dorf", "Wabern", "Liebefeld", "Niederwangen", "Schliern"],
    "La Chaux-de-Fonds": ["Centre", "Les Eplatures", "La Cibourg"],
    "Fribourg": ["Altstadt", "Pérolles", "Beauregard", "Schönberg", "Moncor"],
    "Schaffhausen": ["Altstadt", "Breite", "Niklausen", "Herblingen"],
    "Chur": ["Altstadt", "Masans", "Lachen", "Sand"],
    "Neuchâtel": ["Centre", "Serrières", "La Coudre", "Peseux"],
    "Sion": ["Vieille Ville", "Bramois", "Uvrier", "Châteauneuf"],
    "Yverdon-les-Bains": ["Centre", "Pierre-de-Savoie", "Grandson"],
    "Uster": ["Zentrum", "Nänikon", "Niederuster", "Oberuster"],
    "Zug": ["Altstadt", "Lorzen", "Oberwil", "Walchwil"],
    "Montreux": ["Centre", "Clarens", "Territet", "Veytaux"],
    "Aarau": ["Altstadt", "Rohr", "Buchs", "Suhr"],
    "Baden": ["Altstadt", "Dättwil", "Rütihof", "Ennetbaden"],
    "Wettingen": ["Zentrum", "Tägerhard", "Langenstein"],
    "Olten": ["Altstadt", "Trimbach", "Wangen", "Hägendorf"],
    "Solothurn": ["Altstadt", "Zuchwil", "Bellach", "Langendorf"],
    "Bellinzona": ["Centro", "Carasso", "Giubiasco", "Sementina"],
    "Locarno": ["Centro", "Muralto", "Minusio", "Ascona"],
    "Rapperswil-Jona": ["Rapperswil", "Jona", "Kempraten", "Wagen"],
    "Wil": ["Altstadt", "Bronschhofen", "Rossrüti"],
    "Dietikon": ["Zentrum", "Silbern", "Kindhausen"],
    "Horgen": ["Zentrum", "Käpfnach", "Arn"],
    "Dübendorf": ["Zentrum", "Stettbach", "Gockhausen"],
    "Kloten": ["Zentrum", "Balsberg", "Gerlisberg"],
    "Opfikon": ["Glattbrugg", "Oberhausen", "Glattpark"],
  },
  "Sweden": {
    "Stockholm": ["Rinkeby", "Tensta", "Husby", "Kista", "Sollentuna", "Södertälje", "Botkyrka"],
    "Gothenburg": ["Angered", "Bergsjön", "Biskopsgården", "Hisingen"],
    "Malmö": ["Rosengård", "Fosie", "Lindängen", "Möllevången"],
    "Uppsala": ["Gottsunda", "Stenhagen", "Eriksberg"],
    "Västerås": ["Bäckby", "Skallberget", "Pettersberg"],
  },
  "Denmark": {
    "Copenhagen": ["Nørrebro", "Vesterbro", "Amager", "Nordvest", "Brønshøj"],
    "Aarhus": ["Gellerup", "Brabrand", "Viby", "Hasle"],
    "Odense": ["Vollsmose", "Bolbro", "Dalum"],
    "Aalborg": ["Aalborg Øst", "Nørresundby", "Vejgaard"],
  },
  "Norway": {
    "Oslo": ["Grønland", "Tøyen", "Stovner", "Grorud", "Furuset", "Søndre Nordstrand"],
    "Bergen": ["Landås", "Årstad", "Laksevåg", "Fyllingsdalen"],
    "Trondheim": ["Saupstad", "Tiller", "Heimdal"],
    "Stavanger": ["Storhaug", "Hillevåg", "Hundvåg"],
    "Drammen": ["Fjell", "Strømsø", "Brakerøya"],
  },
  "Finland": {
    "Helsinki": ["Itäkeskus", "Kontula", "Vuosaari", "Malmi", "Kannelmäki"],
    "Espoo": ["Leppävaara", "Matinkylä", "Espoon keskus"],
    "Tampere": ["Hervanta", "Tesoma", "Kaleva"],
    "Turku": ["Varissuo", "Runosmäki", "Pansio"],
    "Vantaa": ["Myyrmäki", "Tikkurila", "Koivukylä"],
  },
  "Italy": {
    "Rome": ["Esquilino", "Pigneto", "Torpignattara", "Centocelle", "Tiburtino"],
    "Milan": ["Via Padova", "Loreto", "Lambrate", "Niguarda", "Quarto Oggiaro"],
    "Turin": ["Porta Palazzo", "San Salvario", "Barriera di Milano", "Aurora"],
    "Naples": ["Centro Storico", "Forcella", "Quartieri Spagnoli", "Vomero"],
    "Bologna": ["Bolognina", "Navile", "San Donato", "Pilastro"],
    "Florence": ["Centro", "Novoli", "Rifredi", "Campo di Marte"],
    "Genoa": ["Centro", "Sampierdarena", "Sestri Ponente", "Marassi"],
    "Palermo": ["Ballarò", "Vucciria", "Zisa", "Borgo Vecchio"],
    "Brescia": ["Centro", "San Polo", "Lamarmora"],
    "Verona": ["Veronetta", "Borgo Roma", "Santa Lucia"],
  },
  "Spain": {
    "Madrid": ["Lavapiés", "Usera", "Vallecas", "Carabanchel", "Tetuán", "Villaverde"],
    "Barcelona": ["Raval", "Ciutat Vella", "Nou Barris", "Sant Martí", "Hospitalet"],
    "Valencia": ["Russafa", "Benimaclet", "Orriols", "Patraix"],
    "Seville": ["Macarena", "Triana", "Cerro del Águila", "Los Remedios"],
    "Bilbao": ["San Francisco", "Zabala", "Otxarkoaga", "Santutxu"],
    "Malaga": ["Centro", "La Palmilla", "Cruz de Humilladero"],
    "Zaragoza": ["Delicias", "San José", "Las Fuentes", "Oliver"],
    "Alicante": ["Centro", "Virgen del Remedio", "Juan XXIII"],
    "Murcia": ["Centro", "Espinardo", "El Carmen"],
  },
  "Portugal": {
    "Lisbon": ["Mouraria", "Martim Moniz", "Arroios", "Amadora", "Loures", "Odivelas"],
    "Porto": ["Campanhã", "Paranhos", "Bonfim", "Aldoar"],
    "Braga": ["Centro", "São Victor", "Este"],
    "Coimbra": ["Centro", "Celas", "Solum"],
    "Faro": ["Centro", "Montenegro", "Gambelas"],
  },
  "Greece": {
    "Athens": ["Omonia", "Metaxourgeio", "Kypseli", "Patisia", "Nea Ionia", "Peristeri"],
    "Thessaloniki": ["Kamara", "Vardaris", "Ano Poli", "Kalamaria"],
    "Piraeus": ["Centrum", "Nikaia", "Keratsini"],
    "Patras": ["Centro", "Psila Alonia", "Marouda"],
    "Rhodes": ["Old Town", "New Town", "Ixia"],
  },
  "Poland": {
    "Warsaw": ["Praga", "Wola", "Mokotów", "Bielany", "Targówek"],
    "Krakow": ["Stare Miasto", "Nowa Huta", "Podgórze", "Bronowice"],
    "Wroclaw": ["Stare Miasto", "Krzyki", "Śródmieście", "Fabryczna"],
    "Poznan": ["Stare Miasto", "Jeżyce", "Wilda", "Grunwald"],
    "Gdansk": ["Główne Miasto", "Wrzeszcz", "Oliwa", "Przymorze"],
    "Lodz": ["Śródmieście", "Bałuty", "Widzew", "Górna"],
  },
  "Czech Republic": {
    "Prague": ["Staré Město", "Vinohrady", "Žižkov", "Karlín", "Smíchov", "Holešovice"],
    "Brno": ["Centrum", "Židenice", "Královo Pole", "Bystrc"],
    "Ostrava": ["Centrum", "Poruba", "Hrabůvka", "Zábřeh"],
    "Pilsen": ["Centrum", "Bory", "Doubravka"],
  },
  "Hungary": {
    "Budapest": ["Józsefváros", "Erzsébetváros", "Kőbánya", "Újpest", "Csepel", "Angyalföld"],
    "Debrecen": ["Centrum", "Tócóskert", "Újkert"],
    "Szeged": ["Centrum", "Móraváros", "Alsóváros"],
    "Miskolc": ["Centrum", "Avas", "Diósgyőr"],
  },
  "Romania": {
    "Bucharest": ["Centru", "Drumul Taberei", "Militari", "Rahova", "Pantelimon"],
    "Cluj-Napoca": ["Centru", "Mărăști", "Mănăștur", "Gheorgheni"],
    "Timisoara": ["Centru", "Fabric", "Iosefin", "Elisabetin"],
    "Iasi": ["Centru", "Nicolina", "Alexandru cel Bun"],
  },
  "Bulgaria": {
    "Sofia": ["Centrum", "Lyulin", "Mladost", "Nadezhda", "Slatina"],
    "Plovdiv": ["Centrum", "Trakiya", "Stolipinovo", "Komatevo"],
    "Varna": ["Centrum", "Vladislavovo", "Asparuhovo"],
    "Burgas": ["Centrum", "Meden Rudnik", "Izgrev"],
  },
  "Croatia": {
    "Zagreb": ["Centar", "Novi Zagreb", "Dubrava", "Trešnjevka", "Maksimir"],
    "Split": ["Centar", "Spinut", "Sućidar", "Ravne njive"],
    "Rijeka": ["Centar", "Trsat", "Sušak", "Kantrida"],
  },
  "Serbia": {
    "Belgrade": ["Stari Grad", "Novi Beograd", "Voždovac", "Zvezdara", "Palilula"],
    "Novi Sad": ["Centar", "Liman", "Detelinara", "Satelit"],
    "Niš": ["Centar", "Ledena Stena", "Čalije"],
  },
  "Slovenia": {
    "Ljubljana": ["Center", "Bežigrad", "Moste-Polje", "Šiška"],
    "Maribor": ["Center", "Pobrežje", "Tezno"],
  },
  "Slovakia": {
    "Bratislava": ["Staré Mesto", "Petržalka", "Ružinov", "Nové Mesto"],
    "Košice": ["Staré Mesto", "Sídlisko KVP", "Terasa"],
  },
  "Ireland": {
    "Dublin": ["City Centre", "Tallaght", "Blanchardstown", "Ballymun", "Clondalkin"],
    "Cork": ["City Centre", "Blackpool", "Ballincollig", "Mayfield"],
    "Galway": ["City Centre", "Ballybane", "Knocknacarra"],
  },
  "Russia": {
    "Moscow": ["Центр", "Арбат", "Марьино", "Выхино", "Бутово", "Митино"],
    "Saint Petersburg": ["Центр", "Купчино", "Приморский", "Выборгский"],
    "Kazan": ["Центр", "Азино", "Горки", "Танкодром"],
    "Novosibirsk": ["Центр", "Калининский", "Ленинский"],
  },
  "Ukraine": {
    "Kyiv": ["Центр", "Оболонь", "Троєщина", "Дарниця", "Борщагівка"],
    "Kharkiv": ["Центр", "Салтівка", "Олексіївка", "Холодна Гора"],
    "Odesa": ["Центр", "Таїрова", "Молдаванка", "Чорноморка"],
    "Lviv": ["Центр", "Сихів", "Рясне", "Левандівка"],
  },

  // Middle East & North Africa
  "United Arab Emirates": {
    "Dubai": ["Deira", "Bur Dubai", "Al Karama", "Al Satwa", "Jumeirah", "Marina", "Downtown", "Business Bay", "Al Barsha", "JBR", "Palm Jumeirah", "Silicon Oasis", "International City", "Al Quoz", "Al Nahda", "Mirdif", "Al Rashidiya"],
    "Abu Dhabi": ["Al Khalidiyah", "Al Nahyan", "Tourist Club", "Mussafah", "Al Reem Island", "Yas Island", "Saadiyat Island", "Al Ain", "Khalifa City", "Mohammed Bin Zayed City", "Al Shamkha", "Baniyas", "Al Mushrif"],
    "Sharjah": ["Al Majaz", "Al Nahda", "Al Qasimia", "Al Khan", "Al Taawun", "Muwaileh", "Industrial Area", "Al Wahda", "Al Yarmook", "University City"],
    "Ajman": ["Al Nuaimiya", "Al Rashidiya", "Al Jurf", "Musheiref", "Al Hamidiya", "Emirates City"],
    "Ras Al Khaimah": ["Al Nakheel", "Al Hamra", "Al Dhait", "Khuzam", "Al Qusaidat", "Mina Al Arab"],
    "Fujairah": ["Fujairah City", "Dibba Al-Fujairah", "Kalba", "Al Faseel", "Qidfa"],
    "Umm Al Quwain": ["Umm Al Quwain City", "Falaj Al Moalla", "Al Salamah", "Al Raas"],
  },
  "Saudi Arabia": {
    "Riyadh": ["Al Olaya", "Al Malaz", "Al Batha", "Al Sulay", "Al Nakheel", "Al Yasmin", "Al Sahafa", "Al Murabba", "Al Worood", "Al Rawdah", "Exit 10", "Exit 5"],
    "Jeddah": ["Al Balad", "Al Hamra", "Al Safa", "Al Rawda", "Al Andalus", "Al Faisaliyah", "Al Shati", "Al Salamah", "Al Zahra", "Al Rehab"],
    "Dammam": ["Al Faisaliyah", "Al Adamah", "Al Shati", "Al Anoud", "Al Khalij", "Al Mazruiyah"],
    "Mecca": ["Al Haram", "Al Aziziyah", "Al Naseem", "Al Awali", "Al Shoqiyah", "Al Rusaifa"],
    "Medina": ["Al Haram", "Al Uyun", "Al Azhari", "Al Khalidiyah", "Quba"],
    "Khobar": ["Al Khobar North", "Al Khobar South", "Corniche", "Al Thuqbah", "Al Aqrabiyah"],
    "Tabuk": ["Al Muruj", "Al Faisaliyah", "Al Nakheel", "Al Rawdah"],
    "Taif": ["Al Hada", "Al Shafa", "Al Salamah", "Al Faisaliyah"],
  },
  "Qatar": {
    "Doha": ["West Bay", "Al Sadd", "Old Airport", "Industrial Area", "Al Wakra", "The Pearl", "Lusail", "Al Dafna", "Musheireb", "Al Rayyan", "Al Gharrafa", "Al Khor"],
  },
  "Kuwait": {
    "Kuwait City": ["Salmiya", "Hawalli", "Farwaniya", "Jahra", "Ahmadi", "Sabah Al Salem", "Mangaf", "Fahaheel", "Mishref", "Bayan", "Salwa", "Shaab"],
  },
  "Bahrain": {
    "Manama": ["Adliya", "Juffair", "Hoora", "Seef", "Muharraq", "Riffa", "Isa Town", "Hamad Town", "Sitra", "Budaiya", "Amwaj Islands"],
  },
  "Oman": {
    "Muscat": ["Mutrah", "Ruwi", "Al Khuwair", "Seeb", "Bausher", "Qurum", "Al Ghubra", "Madinat Sultan Qaboos", "Wadi Kabir", "Al Amerat"],
    "Salalah": ["Al Hafa", "Al Saada", "Awqad", "Dahariz"],
    "Sohar": ["Sohar City", "Falaj Al Qabail", "Al Multaqa"],
    "Nizwa": ["Nizwa City", "Birkat Al Mouz", "Bahla"],
  },
  "Jordan": {
    "Amman": ["Downtown", "Jabal Amman", "Sweifieh", "Abdoun", "Shmeisani", "Khalda", "Dabouq", "Al Rabieh", "Tla Al Ali", "Um Uthaina"],
    "Zarqa": ["Al Zarqa", "Russeifa", "Al Hashimiyya"],
    "Irbid": ["Irbid City", "Al Husn", "Al Ramtha"],
    "Aqaba": ["Aqaba City", "Tala Bay", "Ayla"],
  },
  "Lebanon": {
    "Beirut": ["Hamra", "Achrafieh", "Verdun", "Mar Mikhael", "Bourj Hammoud", "Gemmayzeh", "Downtown", "Badaro", "Ras Beirut", "Ain El Tineh"],
    "Tripoli": ["El Mina", "Abu Samra", "El Qobbe", "Al Tal", "El Bahsas"],
    "Sidon": ["Sidon City", "Abra", "Ghazieh"],
    "Jounieh": ["Jounieh Bay", "Kaslik", "Zouk Mosbeh"],
  },
  "Israel": {
    "Tel Aviv": ["Florentin", "Neve Tzedek", "Jaffa", "Ramat Gan", "Holon", "Bat Yam", "Herzliya", "Rishon LeZion", "Petah Tikva"],
    "Jerusalem": ["West Jerusalem", "East Jerusalem", "Talpiot", "Beit Hanina", "Ramot", "Givat Shaul"],
    "Haifa": ["Downtown", "Hadar", "Bat Galim", "Carmel", "Neve Sha'anan"],
    "Netanya": ["City Center", "Kiryat Hasharon", "Ramat Poleg"],
    "Beer Sheva": ["Old City", "Ramot", "Neve Ze'ev"],
  },
  "Egypt": {
    "Cairo": ["Downtown", "Heliopolis", "Maadi", "Nasr City", "6th of October"],
    "Alexandria": ["Al Raml", "Sidi Gaber", "Smouha", "Miami"],
    "Giza": ["Dokki", "Mohandessin", "Haram"],
  },
  "Morocco": {
    "Casablanca": ["Centre", "Derb Sultan", "Maarif", "Ain Sebaa"],
    "Rabat": ["Centre", "Agdal", "Hassan", "Yacoub El Mansour"],
    "Marrakech": ["Medina", "Guéliz", "Hivernage"],
    "Fes": ["Medina", "Ville Nouvelle", "Route Imouzzer"],
  },
  "Tunisia": {
    "Tunis": ["Centre", "La Marsa", "Bardo", "El Menzah"],
    "Sfax": ["Medina", "Sakiet Ezzit", "Sakiet Eddaier"],
  },
  "Algeria": {
    "Algiers": ["Casbah", "Bab El Oued", "Kouba", "Hussein Dey"],
    "Oran": ["Centre", "Es-Senia", "Bir El Djir"],
  },
  "Libya": {
    "Tripoli": ["Old City", "Bab Ben Ghashir", "Abu Salim", "Hay Al-Andalus"],
    "Benghazi": ["Centre", "Sidi Hsein", "Sabri"],
  },
  "Iraq": {
    "Baghdad": ["Karrada", "Mansour", "Adhamiyah", "Sadr City"],
    "Erbil": ["Ankawa", "Ainkawa", "Rizgary"],
    "Basra": ["Centre", "Ashar", "Jumhuriya"],
  },
  "Iran": {
    "Tehran": ["District 6", "District 12", "District 15", "District 4", "Tajrish"],
    "Isfahan": ["Centre", "Jolfa", "Khaneh"],
    "Mashhad": ["Centre", "Samen", "Vakil Abad"],
    "Tabriz": ["Centre", "Shahgoli", "Abresan"],
  },

  // Asia
  "China": {
    "Beijing": ["Chaoyang", "Haidian", "Dongcheng", "Xicheng", "Fengtai"],
    "Shanghai": ["Pudong", "Jing'an", "Huangpu", "Xuhui", "Changning"],
    "Guangzhou": ["Tianhe", "Yuexiu", "Haizhu", "Baiyun"],
    "Shenzhen": ["Futian", "Nanshan", "Luohu", "Bao'an"],
  },
  "Japan": {
    "Tokyo": ["Shinjuku", "Shibuya", "Ikebukuro", "Shin-Okubo", "Ueno", "Asakusa"],
    "Osaka": ["Namba", "Umeda", "Tennoji", "Shinsekai"],
    "Nagoya": ["Sakae", "Kanayama", "Osu"],
    "Yokohama": ["Yokohama Station", "Chinatown", "Kannai"],
  },
  "South Korea": {
    "Seoul": ["Itaewon", "Hongdae", "Gangnam", "Myeongdong", "Dongdaemun"],
    "Busan": ["Seomyeon", "Haeundae", "Nampo"],
    "Incheon": ["Bupyeong", "Juan", "Dongchun"],
  },
  "India": {
    "Mumbai": ["Andheri", "Bandra", "Colaba", "Kurla", "Dharavi"],
    "Delhi": ["Chandni Chowk", "Connaught Place", "Karol Bagh", "Lajpat Nagar"],
    "Bangalore": ["MG Road", "Koramangala", "Indiranagar", "Whitefield"],
    "Chennai": ["T. Nagar", "Anna Nagar", "Adyar", "Velachery"],
  },
  "Pakistan": {
    "Karachi": ["Saddar", "Clifton", "Gulshan", "North Nazimabad"],
    "Lahore": ["Gulberg", "Model Town", "Defence", "Anarkali"],
    "Islamabad": ["F-7", "F-6", "G-9", "Blue Area"],
  },
  "Bangladesh": {
    "Dhaka": ["Gulshan", "Banani", "Dhanmondi", "Mirpur", "Uttara"],
    "Chittagong": ["Agrabad", "Pahartali", "Nasirabad"],
  },
  "Indonesia": {
    "Jakarta": ["Menteng", "Kemang", "Kuningan", "Kelapa Gading"],
    "Surabaya": ["Genteng", "Gubeng", "Rungkut"],
    "Bandung": ["Dago", "Braga", "Buah Batu"],
  },
  "Malaysia": {
    "Kuala Lumpur": ["Bukit Bintang", "Bangsar", "Mont Kiara", "Cheras"],
    "Penang": ["George Town", "Bayan Lepas", "Air Itam"],
    "Johor Bahru": ["City Centre", "Taman Molek", "Skudai"],
  },
  "Singapore": {
    "Singapore": ["Orchard", "Marina Bay", "Bugis", "Little India", "Chinatown", "Geylang"],
  },
  "Thailand": {
    "Bangkok": ["Sukhumvit", "Silom", "Khao San", "Pratunam", "Chinatown"],
    "Chiang Mai": ["Old City", "Nimmanhaemin", "Night Bazaar"],
    "Phuket": ["Patong", "Kata", "Karon", "Phuket Town"],
  },
  "Vietnam": {
    "Ho Chi Minh City": ["District 1", "District 3", "District 7", "Binh Thanh"],
    "Hanoi": ["Hoan Kiem", "Ba Dinh", "Dong Da", "Cau Giay"],
  },
  "Philippines": {
    "Manila": ["Makati", "BGC", "Quezon City", "Pasig", "Mandaluyong"],
    "Cebu": ["IT Park", "Lahug", "Mandaue"],
  },

  // Americas
  "United States": {
    "New York": ["Manhattan", "Brooklyn", "Queens", "Bronx", "Staten Island", "Paterson NJ"],
    "Los Angeles": ["Downtown", "Hollywood", "Glendale", "Pasadena", "West LA"],
    "Chicago": ["Lincoln Square", "Rogers Park", "Albany Park", "Devon"],
    "Houston": ["Hillcroft", "Bellaire", "Westheimer", "Harwin"],
    "Washington DC": ["Adams Morgan", "Georgetown", "Dupont Circle", "Arlington VA"],
    "Boston": ["Cambridge", "Somerville", "Watertown", "Brighton"],
    "San Francisco": ["Tenderloin", "Mission", "Sunset", "Richmond"],
    "Miami": ["Little Havana", "Doral", "Hialeah", "Kendall"],
    "Philadelphia": ["Center City", "University City", "North Philadelphia"],
    "Detroit": ["Dearborn", "Hamtramck", "Troy", "Southfield"],
    "Atlanta": ["Clarkston", "Chamblee", "Doraville", "Decatur"],
    "Dallas": ["Richardson", "Garland", "Irving", "Carrollton"],
    "Phoenix": ["Mesa", "Tempe", "Scottsdale", "Chandler"],
    "Seattle": ["Rainier Valley", "Tukwila", "Renton", "Bellevue"],
    "San Diego": ["City Heights", "El Cajon", "Chula Vista"],
    "Denver": ["Aurora", "Lakewood", "Westminster"],
  },
  "Canada": {
    "Toronto": ["Thorncliffe Park", "Scarborough", "North York", "Mississauga", "Brampton"],
    "Montreal": ["Parc-Extension", "Côte-des-Neiges", "Saint-Laurent", "Laval"],
    "Vancouver": ["Commercial Drive", "Surrey", "Burnaby", "Richmond"],
    "Ottawa": ["Vanier", "Orleans", "Nepean", "Kanata"],
    "Calgary": ["Northeast", "Forest Lawn", "Marlborough"],
    "Edmonton": ["Mill Woods", "Castle Downs", "Millbourne"],
  },
  "Mexico": {
    "Mexico City": ["Centro", "Polanco", "Roma", "Condesa", "Coyoacán"],
    "Guadalajara": ["Centro", "Zapopan", "Tlaquepaque"],
    "Monterrey": ["Centro", "San Pedro", "Santa Catarina"],
    "Tijuana": ["Centro", "Zona Río", "Playas"],
  },
  "Brazil": {
    "São Paulo": ["Centro", "Liberdade", "Bela Vista", "Moema", "Vila Mariana"],
    "Rio de Janeiro": ["Centro", "Copacabana", "Ipanema", "Botafogo"],
    "Brasília": ["Asa Sul", "Asa Norte", "Taguatinga"],
  },
  "Argentina": {
    "Buenos Aires": ["Palermo", "San Telmo", "Recoleta", "Belgrano", "Once"],
  },
  "Colombia": {
    "Bogotá": ["Chapinero", "Usaquén", "Kennedy", "Suba"],
    "Medellín": ["El Poblado", "Laureles", "Centro"],
  },
  "Chile": {
    "Santiago": ["Las Condes", "Providencia", "Ñuñoa", "Maipú"],
  },
  "Peru": {
    "Lima": ["Miraflores", "San Isidro", "Barranco", "La Victoria"],
  },

  // Africa
  "South Africa": {
    "Johannesburg": ["Sandton", "Rosebank", "Fordsburg", "Hillbrow"],
    "Cape Town": ["City Bowl", "Sea Point", "Observatory", "Woodstock"],
    "Durban": ["City Centre", "Morningside", "Berea"],
  },
  "Nigeria": {
    "Lagos": ["Victoria Island", "Ikoyi", "Lekki", "Ikeja", "Surulere"],
    "Abuja": ["Wuse", "Garki", "Maitama", "Asokoro"],
  },
  "Kenya": {
    "Nairobi": ["Westlands", "Kilimani", "Karen", "Eastleigh"],
  },
  "Ethiopia": {
    "Addis Ababa": ["Bole", "Kirkos", "Lideta", "Yeka"],
  },
  "Ghana": {
    "Accra": ["Osu", "Cantonments", "East Legon", "Dansoman"],
  },
  "Senegal": {
    "Dakar": ["Plateau", "Medina", "Parcelles Assainies", "Ouakam"],
  },

  // Oceania
  "Australia": {
    "Sydney": ["Auburn", "Lakemba", "Bankstown", "Parramatta", "Liverpool", "Merrylands"],
    "Melbourne": ["Brunswick", "Coburg", "Preston", "Footscray", "Dandenong"],
    "Brisbane": ["Moorooka", "Sunnybank", "Inala", "Logan"],
    "Perth": ["Mirrabooka", "Balga", "Cannington", "Victoria Park"],
    "Adelaide": ["Prospect", "Blair Athol", "Kilburn", "Modbury"],
  },
  "New Zealand": {
    "Auckland": ["Mt Roskill", "Avondale", "New Lynn", "Panmure"],
    "Wellington": ["Newtown", "Kilbirnie", "Lower Hutt"],
    "Christchurch": ["Riccarton", "Linwood", "Hornby"],
  },
};

// Get country name translation key
export const getCountryKey = (countryName) => {
  const keyMap = {
    "Türkiye": "turkey",
    "Germany": "germany",
    "Netherlands": "netherlands",
    "Belgium": "belgium",
    "France": "france",
    "United Kingdom": "uk",
    "Austria": "austria",
    "Switzerland": "switzerland",
    "Sweden": "sweden",
    "Denmark": "denmark",
    "Norway": "norway",
    "Finland": "finland",
    "Italy": "italy",
    "Spain": "spain",
    "Portugal": "portugal",
    "Greece": "greece",
    "Poland": "poland",
    "Czech Republic": "czechRepublic",
    "Hungary": "hungary",
    "Romania": "romania",
    "Bulgaria": "bulgaria",
    "Croatia": "croatia",
    "Serbia": "serbia",
    "Slovenia": "slovenia",
    "Slovakia": "slovakia",
    "Ireland": "ireland",
    "Russia": "russia",
    "Ukraine": "ukraine",
    "United Arab Emirates": "uae",
    "Saudi Arabia": "saudiArabia",
    "Qatar": "qatar",
    "Kuwait": "kuwait",
    "Bahrain": "bahrain",
    "Oman": "oman",
    "Jordan": "jordan",
    "Lebanon": "lebanon",
    "Israel": "israel",
    "Egypt": "egypt",
    "Morocco": "morocco",
    "Tunisia": "tunisia",
    "Algeria": "algeria",
    "Libya": "libya",
    "Iraq": "iraq",
    "Iran": "iran",
    "China": "china",
    "Japan": "japan",
    "South Korea": "southKorea",
    "India": "india",
    "Pakistan": "pakistan",
    "Bangladesh": "bangladesh",
    "Indonesia": "indonesia",
    "Malaysia": "malaysia",
    "Singapore": "singapore",
    "Thailand": "thailand",
    "Vietnam": "vietnam",
    "Philippines": "philippines",
    "United States": "usa",
    "Canada": "canada",
    "Mexico": "mexico",
    "Brazil": "brazil",
    "Argentina": "argentina",
    "Colombia": "colombia",
    "Chile": "chile",
    "Peru": "peru",
    "South Africa": "southAfrica",
    "Nigeria": "nigeria",
    "Kenya": "kenya",
    "Ethiopia": "ethiopia",
    "Ghana": "ghana",
    "Senegal": "senegal",
    "Australia": "australia",
    "New Zealand": "newZealand",
  };
  return keyMap[countryName] || countryName.toLowerCase().replace(/\s+/g, '');
};

// Get city name translation key - normalized for i18n
export const getCityKey = (cityName) => {
  if (!cityName) return '';
  // Normalize: lowercase, remove special chars, replace spaces with camelCase
  return cityName
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[^a-z0-9\s]/g, '')
    .split(/\s+/)
    .map((word, i) => i === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
};

// Get district name translation key - normalized for i18n
export const getDistrictKey = (districtName) => {
  if (!districtName) return '';
  // Normalize: lowercase, remove special chars, replace spaces with camelCase
  return districtName
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[^a-z0-9\s]/g, '')
    .split(/\s+/)
    .map((word, i) => i === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
};

export default worldCountries;
